import React, { useState, useEffect } from 'react';
import './App.css';
import { auth } from './firebase';
import { onAuthStateChanged, signInAnonymously } from 'firebase/auth';
import Header from './components/Header';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Giving from './pages/Giving';
import GivingLanding from './pages/GivingLanding';
import Media from './pages/Media';
import Events from './pages/Events';
import Prayer from './pages/Prayer';
import Profile from './pages/Profile';
import PrivacyPolicy from './pages/PrivacyPolicy';
import JoinGroup from './pages/JoinGroup';
import SermonCalendar from './pages/SermonCalendar';
import SermonNotes from './pages/SermonNotes';

const PAGES = [
  { id: 'home',         label: '🏠 Inicio' },
  { id: 'events',       label: '📅 Eventos' },
  { id: 'giving',       label: '🙏 Dar' },
  { id: 'prayer-modal', label: '🙏 Oración' },
  { id: 'media',        label: '📺 En Vivo' },
];

function App() {
  const [activePage, setActivePage]   = useState('home');
  const [user, setUser]               = useState(null);

  const navigate = (page) => {
    setActivePage(page);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };
  const [authLoading, setAuthLoading] = useState(true);
  const [showProfile, setShowProfile] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setAuthLoading(false), 5000);
    const unsub = onAuthStateChanged(auth, async (u) => {
      clearTimeout(timeout);
      if (u) {
        setUser(u);
      } else {
        setUser(null);
        try {
          const result = await signInAnonymously(auth);
          setUser(result.user);
        } catch (e) {
          console.error('Auth error:', e);
        }
      }
      setAuthLoading(false);
    });
    return () => { unsub(); clearTimeout(timeout); };
  }, []);

  if (authLoading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: '#1a2c5b',
        flexDirection: 'column', gap: 16,
      }}>
        <div style={{ fontSize: '2.5rem' }}>✝</div>
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.9rem' }}>Cargando...</p>
      </div>
    );
  }

  if (showProfile) {
    return (
      <div className="app">
        <Header user={user} onProfileClick={() => setShowProfile(false)} showBack />
        <main className="main-content">
          <Profile user={user} onLogout={() => { setUser(null); setShowProfile(false); }} onLogin={(u) => { setUser(u); }} navigate={(p) => { setShowProfile(false); navigate(p); }} />
        </main>
        <Nav pages={PAGES} active={null} onNavigate={(page) => { setShowProfile(false); navigate(page); }} />
        <Footer />
      </div>
    );
  }

  const renderPage = () => {
    switch (activePage) {
      case 'services':     return <Services />;
      case 'giving':       return <GivingLanding navigate={navigate} />;
      case 'give-form':    return <Giving navigate={navigate} />;
      case 'media':        return <Media />;
      case 'events':       return <Events navigate={navigate} />;
      case 'join-group':      return <JoinGroup navigate={navigate} />;
      case 'sermon-calendar': return <SermonCalendar navigate={navigate} />;
      case 'prayer-modal':   return <Prayer />;
      case 'privacy-policy': return <PrivacyPolicy navigate={navigate} />;
      default:
        if (activePage.startsWith('sermon-202')) {
          const dateKey = activePage.replace('sermon-', '');
          return <SermonNotes dateKey={dateKey} navigate={navigate} />;
        }
        return <Home navigate={navigate} />;
    }
  };

  return (
    <div className="app">
      <Header user={user} onProfileClick={() => setShowProfile(true)} />
      <Nav pages={PAGES} active={activePage} onNavigate={navigate} />
      <main className="main-content">
        {renderPage()}
      </main>
      <Footer />
    </div>
  );
}

export default App;
